import tokens from './tokens'
import { SeriesConfig, SeriesKey } from './types'

const serieses: SeriesConfig[] = [
  {
    sid: 0,
    key: SeriesKey.SERIES0,
    name: 'Series #0',
    boxType: 'DMU Generals',
    address: {
      250: '0x2dF7E6537BefB7730e790143e2558945e9538fC2',
      4002: '0x9DB835D1927CC04E50fdeca0642eca06b26de719',
    },
    pool: {
      250: '0xbAE82a392824d957F74dfD96D6C0E6bC732307C1',
      4002: '0x71761A38Fbb2D643Eb29A100edF0587e8306960D',
    },
    dmdMaster: {
      250: '0x2ec10b3dDcc7db82Af160bd21E2459d8C0CBCBd2',
      4002: '',
    },
    getPriceFunc: 'price',
    image: 'series0.png',
    maxSupplyFunc: 'MAX_SUPPLY',
    releaseDate: '2021/12/28',
    minDmdBalanceToMint: 10,
    nftkeyColName: 'dmdunboxedgenerals',
    operaHouse: 'Unboxed Generals',
    withoutMC: true,
  },
  {
    sid: 1,
    key: SeriesKey.FOUNDER,
    name: 'Founder Token',
    address: {
      250: '0xf11cD86667A5a16E1a9d4971c9a518f3d447b8f3',
    },
    pool: {
      250: '0x620dC54286956679f271B5e825214ff6d272a740',
    },
    dmdMaster: {
      250: '0xb2f65a738b5d4355f1315BB3dcF352C06f3C1986',
      4002: '',
    },
    notFromERC721Enumerable: true,
    image: 'founder-token.jpg',
    maxSupplyFunc: '_totalSupply',
    releaseDate: '2021/10/18',
    paintswap: true,
    operaHouse: 'Founders Token',
    withoutMC: true,
  },
  {
    sid: 2,
    key: SeriesKey.SERIES1,
    name: 'Series #1',
    boxType: 'Boxed Generals',
    address: {
      250: '0x10fa5F0dE00c788C11489308f67922022862b698',
      4002: '0xfba58904a995bDeC927fb03d3D3BA8894e3B3954',
    },
    pool: {
      250: '0xca5Dcd603CF1bD803996026BCf530182aF5E6813',
      4002: '0xfcB1b6F01C8e82ABD63C751ba885a11168a06BFF',
    },
    dmdMaster: {
      250: '0xB791Ad89A0dB872E2116c828A60401eE23E48c68',
      4002: '',
    },
    getPriceFunc: 'price',
    image: 'series1.jpeg',
    maxSupplyFunc: 'MAX_SUPPLY',
    releaseDate: '2022/01/14',
    minDmdBalanceToMint: 100,
    nftkeyColName: 'dmdboxedgenerals',
    operaHouse: 'Boxed Generals',
    // tofu: 'boxed-generals',
    withoutMC: true,
  },
  {
    sid: 3,
    key: SeriesKey.FSMC,
    name: 'FantomSquad Bats',
    address: {
      250: '0xb680b9861f73B30d86BdC248376d9566ade3FD35',
    },
    pool: {
      250: '0x2bB9Fb0bc069C929F63B45B76931D331f9fFF2c6',
    },
    dmdMaster: {
      250: '0x5c830a8b19CdC5e1804Da2132da20f58c8C8d98f',
      4002: '',
    },
    image: 'fantomsquad.png',
    projectLink: 'https://www.fantomsquad.com',
    paintswap: true,
    disableMint: true,
    withoutMC: true,
  },
  {
    sid: 4,
    key: SeriesKey.FTG1,
    name: 'Fantomon NFT',
    address: {
      250: '0x4F46C9D58c9736fe0f0DB5494Cf285E995c17397',
    },
    pool: {
      250: '0x8Ccb6f71a384A1792ba9339e30609f2EE89AB9c8',
    },
    image: 'fantomon.jpeg',
    disableMint: true,
    projectLink: 'https://fantomon.net',
    paintswap: true,
    nftkeyColName: 'fantomon',
  },
  {
    sid: 5,
    key: SeriesKey.SERIES2,
    name: 'Series #2',
    boxType: 'Aliens DarkMatter',
    address: {
      250: '0x6f0f3a583d525129b2fe2f6b7610d516f2d6abb5',
      4002: '0x964cceEfA889f4bB8c114b4252b5d54337e152eC',
    },
    pool: {
      250: '0xa3b4525E67D0aa61E5631C21C6Ba1B039a3279B8',
      4002: '0xfF81C6E30896B64342f6B64d069A42e216f49F02',
    },
    getPriceFunc: 'price',
    image: 'series2.jpg',
    maxSupplyFunc: 'maxSupply',
    releaseDate: '2022/02/07',
    minDmdBalanceToMint: 100,
    nftkeyColName: 'dmdseries2aliens',
    operaHouse: 'Series%202%20%E2%80%93%20Aliens',
    abilityKey: 'Ability',
  },
  {
    sid: 6,
    key: SeriesKey.RACCOON,
    name: 'Raccoon Platoon',
    address: {
      250: '0x9ee3479f88431040f96266c73c6949f4b694e97e',
      4002: '',
    },
    pool: {
      250: '0xBD96D7DC05c7778C72Dd66eAE8d54A21015eAA39',
      4002: '',
    },
    getPriceFunc: 'cost',
    image: 'raccoonplatoon.gif',
    disableMint: true,
    maxSupplyFunc: 'maxSupply',
    projectLink: 'http://raccoonplatoon.com',
    operaHouse: 'Raccoon Platoon',
  },
  {
    sid: 7,
    key: SeriesKey.WEAPONIZED,
    name: 'WeaponizedCountries',
    address: {
      250: '0xc031b7793f17100e9b7ad369ca05e5ec8a0f5b5c',
      4002: '',
    },
    pool: {
      250: '0x3FB5E0560c4E833CD00002540C7b489F8d130e66',
      4002: '',
    },
    getPriceFunc: 'price',
    image: 'weaponized.png',
    disableMint: true,
    maxSupplyFunc: 'MAX_Supply',
    projectLink: 'https://weaponizedcountriesnft.com',
    nftkeyColName: 'weaponizedcountries',
    paintswap: true,
    operaHouse: 'Weaponized%20Countries',
  },
  {
    sid: 8,
    key: SeriesKey.SLURPIESBYZAQ,
    name: 'SlurpiesByZaq',
    address: {
      250: '0xBf2B77b4b3FbbFe1F7a757D1CaB4D294Fc027Ae8',
      4002: '',
    },
    pool: {
      250: '0x798001f8D4D4896D261045B9B1958d50692194F3',
      4002: '',
    },
    rewardToken: tokens.wftm,
    image: 'slurpiesbyzaq.png',
    disableMint: true,
    projectLink: 'https://slurp.wtf',
    paintswap: true,
    operaHouse: 'SlurpiesByZaq',
    nftkeyColName: 'slurpiesbyzaq',
    // tofu: 'slurpiesbyzaq',
  },
  {
    sid: 9,
    key: SeriesKey.YAMALOKA,
    name: 'Yamaloka Warriors',
    address: {
      250: '0xec24694fF3785E6EBF2754479DAB383940cC220E',
      4002: '',
    },
    pool: {
      250: '0x0a655F76e3b124C323D2C44f471F346D909A533d',
      4002: '',
    },
    image: 'yamaloka.png',
    disableMint: true,
    projectLink: 'https://www.yamaloka.world',
    paintswap: true,
    operaHouse: 'The Yamaloka Warriors',
    nftkeyColName: 'yamaloka',
    // tofu: 'the-yamaloka-warriors',
    gateway: 'https://yamaloka.mypinata.cloud/ipfs',
  },
  {
    sid: 10,
    key: SeriesKey.CYBERSTONED,
    name: 'Cyber Stoned',
    address: {
      250: '0xfDb85ca5436E8DcFd3A637564E010BC5DFF21acc',
      4002: '',
    },
    pool: {
      250: '0x0355fd5904FC10B2013cD3B1Af58060d883185F9',
      4002: '',
    },
    notFromERC721Enumerable: true,
    image: 'cyberstoned.png',
    disableMint: true,
    projectLink: 'https://thestonksociety.com',
    paintswap: true,
    // tofu: 'fantom-de-fi-verse-by-cyber-stoned',
  },
  {
    sid: 11,
    key: SeriesKey.STONKSSOCIETY,
    name: 'Stonks Society',
    address: {
      250: '0x2f604079aFf2A11883736d189eF823e39abd6316',
      4002: '',
    },
    pool: {
      250: '0x542c5f159C5598592FA06c83f4948AECA9a6fBf9',
      4002: '',
    },
    image: 'stonksociety.png',
    disableMint: true,
    projectLink: 'https://thestonksociety.com',
    paintswap: true,
    nftkeyColName: 'thestonksociety',
    // tofu: 'the-stonk-society',
  },
  {
    sid: 12,
    key: SeriesKey.TERRA_FORMERS,
    name: 'Terra Formers',
    description:
      'Fantom Terraformers is a collaborative generative project by artist Clokkworky and JakeEY3, 1500 terraformers planet building on the $FTM  blockchain.',
    address: {
      250: '0x9D632cF43A2c75e1d938B3F71397Cc59e63fb2Fb',
      4002: '',
    },
    pool: {
      250: '0x9af564AfECba4329b1e1a3972a07DDA900F510d3',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'terra-formers.jpeg',
    releaseDate: '2022/03/16',
    twitter: 'https://twitter.com/ftm_terraformer?s=21',
    discord: 'https://discord.com/invite/bpWgWAgdcT',
    nftkeyColName: 'ftmterraformers',
    operaHouse: 'TerraFormer',
  },
  {
    sid: 13,
    key: SeriesKey.ONE_LING,
    name: 'One Ring',
    address: {
      250: '0xDf7834cEaDCB94Ef67fBE52BA8ce4c6B2ee12bCc',
      4002: '',
    },
    pool: {
      250: '0x0083EfB4b8Cd3bA422DFD5a23E840545225Fc88e',
      4002: '',
    },
    image: 'one-ling.png',
    disableMint: true,
    projectLink: 'https://www.onering.finance',
    paintswap: true,
  },
  {
    sid: 14,
    key: SeriesKey.NOVA_CHIMP,
    name: 'Nova Chimp',
    address: {
      250: '0x4c6dcdd6d6C6432Ed02B468501C019fca1fe17e2',
      4002: '',
    },
    pool: {
      250: '0xa65d769ABAaCdF52471c7DB74c4eF1578563B2F5',
      4002: '',
    },
    rewardToken: tokens.snt,
    image: 'nova.png',
    disableMint: true,
    projectLink: 'https://novanetwork.io',
    operaHouse: 'Nova%20Chimp%20Gang',
    // tofu: 'nova-chimp-gang',
    gateway: 'https://operahouse.mypinata.cloud/ipfs',
  },
  {
    sid: 15,
    key: SeriesKey.FRENCHIES,
    name: 'Fantom Frenchies',
    description:
      'The Fantom Frenchies is a collection of 690 Hiqh Quality, Hand Drawn French Bulldogs stored on the Fantom Blockchain.',
    address: {
      250: '0xB6902d67e75932A2d353c43490623D6B246f93aA',
      4002: '',
    },
    pool: {
      250: '0xe6b1f28ea447D6cF2d702F87f0d18eFfc1792E61',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'frenchies.gif',
    releaseDate: '2022/03/26',
    twitter: 'https://twitter.com/fantomfrenchies',
    telegram: 'https://t.me/fantomfrenchies',
    nftkeyColName: 'fantomfrenchies',
    operaHouse: 'FantomFrenchies',
    projectLink: 'https://fantomfrenchies.com',
    abilityKey: 'Bark',
  },
  {
    sid: 16,
    key: SeriesKey.PHANTOM_WAVE,
    name: 'Phantom Wave',
    address: {
      250: '0xB5F87c400FdC64345bfa447Cc18d09fAe94972D5',
      4002: '',
    },
    pool: {
      250: '0xbd631344c09a54f0AF89d992eac67f1c57b839E3',
      4002: '',
    },
    image: 'phantomwave.png',
    disableMint: true,
    projectLink: 'https://mint.phantomwaveftm.com',
    nftkeyColName: 'phantomwave',
    operaHouse: 'Phantom%20Wave',
  },
  {
    sid: 17,
    key: SeriesKey.GNARWHALS,
    name: 'Gnarwhals',
    address: {
      250: '0xe871400cd619b3EE99a68287D68e5Cb0827Db49D',
      4002: '',
    },
    pool: {
      250: '0x1d5550e37834166Bfa40A05E5c832E1B3d04df7c',
      4002: '',
    },
    getPriceFunc: 'unitPrice',
    image: 'gnarwhals.png',
    disableMint: true,
    projectLink: 'https://www.ftmgnarwhals.com',
    operaHouse: 'FTM%20Gnarwhals',
  },
  {
    sid: 18,
    key: SeriesKey.CAPYS,
    name: 'FTM Capys',
    description:
      'Fantom Capys is a project inspired by our creator @Goosymane’s South American roots and brought to life by digital artist @avi_m_kabir.',
    address: {
      250: '0x789db87308172a5B4cB3af7Ee05Ad94240C68F79',
      4002: '',
    },
    pool: {
      250: '0x49E005C560D6FB70Ff74B6731dD7e42c89FA3a35',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'capys.gif',
    releaseDate: '2022/03/29',
    discord: 'https://discord.gg/BDEk6z6pvV',
    twitter: 'https://twitter.com/FtmCapys',
    nftkeyColName: 'ftmcapys',
  },
  {
    sid: 19,
    key: SeriesKey.MAGIK,
    name: 'MAGIK NFT',
    address: {
      250: '0xE2B8a9f4d1417acd4a696fa9580A393ef703a619',
      4002: '',
    },
    pool: {
      250: '0x05b3a4DED01c1E335ADf5604eC10E5F8Bc3e0339',
      4002: '',
    },
    rewardToken: tokens.magik,
    getPriceFunc: 'cost',
    image: 'magik.jpeg',
    disableMint: true,
    paintswap: true,
    projectLink: 'https://magik.finance',
    nftkeyColName: 'magiknft',
  },
  {
    sid: 20,
    key: SeriesKey.SLOTH_AVATAR,
    name: 'SlothAvatar',
    address: {
      250: '0x130710B4Fd678Ede793423374041De1052c724Cf',
      4002: '',
    },
    pool: {
      250: '0xCBB1024bA0D9fe37a4362dF4ad43FaDBeF3C5F2a',
      4002: '',
    },
    notFromERC721Enumerable: true,
    getPriceFunc: 'mintCost',
    notEtherPrice: true,
    projectLink: 'https://slothtopianft.com',
    operaHouse: 'Slothtopia%20Avatars',
    image: 'sloth-avatar.PNG',
    disableMint: true,
  },
  {
    sid: 21,
    key: SeriesKey.FAT_BIRDS,
    name: 'Fat Birds',
    description: 'The return of the fattest birds on the FTM blockchain. A generative project by Nedpeppermint.',
    address: {
      250: '0x2cB89968225986fAd8542dAC01c88b462d2B3D4b',
      4002: '',
    },
    pool: {
      250: '0xafCFDC06AcC477288DD9Dd1bAc1efb92DCe19166',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'fat-birds.png',
    releaseDate: '2022/04/09',
    discord: 'https://discord.gg/hstcGkRrCA',
    twitter: 'https://twitter.com/Nedpeppermint',
  },
  {
    sid: 22,
    key: SeriesKey.RACCOON_SNT,
    name: 'Raccoon Platoon ',
    address: {
      250: '0x9ee3479f88431040f96266c73c6949f4b694e97e',
      4002: '',
    },
    pool: {
      250: '0x6F84d21568E9D9d01cd281B2A132bBd312196249',
      4002: '',
    },
    getPriceFunc: 'cost',
    rewardToken: tokens.snt,
    image: 'raccoonplatoon.gif',
    disableMint: true,
    maxSupplyFunc: 'maxSupply',
    projectLink: 'http://raccoonplatoon.com',
    operaHouse: 'Raccoon Platoon',
  },
  {
    sid: 23,
    key: SeriesKey.PAINTHUFFING,
    name: 'Paint Huffing Degens',
    description: 'A collection by Mazochist_LAF',
    address: {
      250: '0x27413f713600f9E159FE7a0C158BA2a78778f37e',
      4002: '',
    },
    pool: {
      250: '0x58424861B87D228fDB09B4834c1b5CB50c50346D',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'painthuffing.png',
    releaseDate: '2022/04/09',
    discord: 'https://discord.gg/UMXNAZmJ5T',
    twitter: 'https://twitter.com/mazochist_laf',
    nftkeyColName: 'painthuffingdegens',
  },
  {
    sid: 24,
    key: SeriesKey.BLAST1,
    name: 'Steven Vinyl - Blast',
    description:
      'Blast is a semi rock-symphonic track conjured in the middle of the night in the quarantine year of 2021. Featuring playful percussion, symphonic brass elements, a calm middle piano section and an explosive ending, hence the name. Released in partnership with Potluck Labs and the Jukebox Collective in 2022.',
    address: {
      250: '0xC433D9D147BEC9a0beA63c8dc8a07B52FAa3B038',
      4002: '',
    },
    pool: {
      250: '0x70efCce3CaB0A779FE582f13508AFC165ffF9bbD',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    animation: 'steven.mp4',
    releaseDate: '2022/04/09',
    discord: 'https://discord.gg/dqkdKxsYsV',
    twitter: 'https://twitter.com/StevenVinyl',
  },
  {
    sid: 25,
    key: SeriesKey.HAMSTERS,
    name: 'Hamsters & Owls Game',
    address: {
      250: '0xFE9F8c2b135012184d41DEdAE0c3f7eE8eF5eB0a',
      4002: '',
    },
    pool: {
      250: '0x74F85Db703FcC460CaCA79D0dC36efFE26b3c443',
      4002: '',
    },
    rewardToken: tokens.ham,
    projectLink: 'https://hno.hamster.money',
    paintswap: true,
    nftkeyColName: 'hamstersandowls',
    image: 'hamsters.png',
    disableMint: true,
  },
  {
    sid: 26,
    key: SeriesKey.SEAHORSES,
    name: 'Sea Horses',
    description:
      'Natuna, Halmahera, Sawu, Arafuru, and Doctor Flores go on amazing adventures to defend Underwater Worlds from Human Pollution!',
    address: {
      250: '0xB2dF07dEF47FBbB3609Ba3fa71de64544816dD73',
      4002: '',
    },
    pool: {
      250: '0x7a3e58a1f44e2e8e3a0bce6d591e3c02efef815d',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'seahorses.gif',
    releaseDate: '2022/04/19',
    discord: 'https://discord.com/invite/5trTBWuCZT',
    twitter: 'https://twitter.com/FantomSeahorses',
    projectLink: 'https://www.fantomseahorses.com/',
    nftkeyColName: 'fantomseahorses',
    abilityKey: 'Recycle',
  },
  {
    sid: 27,
    key: SeriesKey.NATIVEWARRIOR,
    name: 'Native Warriors',
    description:
      'Fantom Native Warriors are here to defend Fantom! Celebrate Native American culture with us! Each Native Warrior has a special Aura level that connects them with Native Spirits! Get in touch with your spirtuality!',
    address: {
      250: '0x89ffa545347A6905aDfA9fe4BA03CE30ED2319db',
      4002: '',
    },
    pool: {
      250: '0xfC8fab5db6c03d2d806DF0059c68b0D5359eE6E0',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'nativewarriors.png',
    releaseDate: '2022/05/07',
    discord: 'https://discord.com/invite/ur3UWEKKtu',
    twitter: 'https://twitter.com/fantomwarriors',
    projectLink: 'https://www.fantomwarriors.com/',
    telegram: 'https://t.me/FTMnativewarriors',
    // nftkeyColName: 'nativewarriors',
  },
  {
    sid: 28,
    key: SeriesKey.ALIENHEADS,
    name: 'Alien Heads',
    description: 'Alien Heads are 333 crazy NFTs with a unique roadmap, launching on the Fantom Network👽',
    address: {
      250: '0xc846DA37D2e0ED947A764C2b41d96D6523143403',
      4002: '',
    },
    pool: {
      250: '0xa202Bcb85a9DB3C601Ae02eF194b4a1c08998b40',
      4002: '',
    },
    // withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'alienheads.gif',
    releaseDate: '2022/05/24',
    discord: 'https://discord.gg/ZbmXBtucVy',
    twitter: 'https://twitter.com/alienheads_nft',
    nftkeyColName: 'alienheads',
  },
  {
    sid: 29,
    key: SeriesKey.PUNKS,
    name: 'Fantom Baby Punks',
    address: {
      250: '0xd7179025B82cb188A6Ce5A58E69e00F16c4E1843',
      4002: '',
    },
    pool: {
      250: '0x4a44fE43Dd9CBE645a7E5E825f93ba28bb61B101',
      4002: '',
    },
    notFromERC721Enumerable: true,
    preTotalSupply: 153,
    image: 'punks.png',
    disableMint: true,
    paintswap: true,
    operaHouse: 'FantomBabyPunks',
  },
  {
    sid: 30,
    key: SeriesKey.RAS_TERMS,
    name: 'RasTerms',
    address: {
      250: '0x7587BB0Af97Fb6eDe8a96cD3C1b1AA9F6BE9a7C0',
      4002: '',
    },
    pool: {
      250: '0xd7d0913722F0c7cE3c70dEB8f597656eE5873ED8',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'ras-terms.jpeg',
    releaseDate: '2022/05/08',
    discord: 'https://discord.com/invite/w6VDQuH95B',
    twitter: 'https://twitter.com/bizarresstar',
    projectLink: 'https://linktr.ee/rasterms',
  },
  {
    sid: 31,
    key: SeriesKey.STARSFALL,
    name: 'Mr. Crowley - Stars Fall',
    description: 'Mr. Crowley - Stars Fall Single Hip Hop',
    address: {
      250: '0x0834295976a2210338BB3EaBc645Dbbf2Cc6cdF9',
      4002: '',
    },
    pool: {
      250: '0x1bF6b5E6E0cE514ab119620862536A195c85B768',
      4002: '',
    },
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'starsfall.png',
    releaseDate: '2022/05/08',
    nftkeyColName: 'starsfall',
  },
  {
    sid: 32,
    key: SeriesKey.EDBANGERZ,
    name: 'Edbangerz',
    description:
      'A collection of 666 grim-dark fantasy, heavy metal inspired NFTs. Spat forth from the immaterium, the ironclad hordes of Edbangerz will march ever forward to the beat of total armageddon. Do you have the strength to stop them?',
    address: {
      250: '0x6B7eCA8c9D87Fa5e9f4b050B8f8b7028294E3AeA',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'edbangerz.png',
    releaseDate: '2022/05/15',
    discord: 'https://discord.com/invite/zEamCEt5',
    twitter: 'https://twitter.com/spearheadirl',
    nftkeyColName: 'edbangerz',
  },
  {
    sid: 33,
    key: SeriesKey.LOVEYOUKITTENS,
    name: 'I Love You More Kittens',
    description:
      '1114 adorable “I Love You More Kittens” dancing in fields of Daffodils & other flower patches! Give as a Mother’s Day gift to the worlds’ most amazing mother!',
    address: {
      250: '0x35B9b8C91387D1D68dce049Dd37A115F0B299598',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'loveyoukittens.png',
    releaseDate: '2022/05/20',
    discord: 'https://discord.gg/zVjcyhMHtg',
    twitter: 'https://twitter.com/iloveyounmorecats',
    telegram: 'https://t.me/loveyoumorecats',
    // nftkeyColName: 'iloveyoukittens',
  },
  {
    sid: 34,
    key: SeriesKey.FANTOMNECROMANCERS,
    name: 'Fantom Necromancers',
    description:
      'FtmNecromancers is the first Grim NFT game on the Fantom blockchain(MMORTS) Based on a classic fantasy narrative with character development as well as territorial strategy',
    address: {
      250: '0x0A6529d0cf2B0C65bdFBDb73eCaDDA7C1aFc360b',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'necro.png',
    releaseDate: '2022/05/21',
    discord: '',
    twitter: 'https://twitter.com/ftmnxcro',
    telegram: 'https://t.me/FTMNecromancers',
    projectLink: 'https://ftmnecromancers.com',
    // nftkeyColName: '',
  },
  {
    sid: 35,
    key: SeriesKey.FANTOWN,
    name: 'Fantown',
    description: '1000 people living in Fantown but some of them are missing!Find them and win prizes!',
    address: {
      250: '0x1917217e3EadE8D05E45dB3827b9645F99e630BF',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'fantown.gif',
    releaseDate: '2022/05/25',
    discord: 'https://discord.com/invite/6JxgWDz5Am',
    twitter: 'https://twitter.com/FantownFTM',
    // projectLink: 'https://ftmnecromancers.com',
    // nftkeyColName: '',
  },
  {
    sid: 36,
    key: SeriesKey.SERIES0_V2,
    name: 'Series #0 - V2',
    collectionName: 'Series #0',
    boxType: 'DMU Generals',
    address: {
      250: '0x2dF7E6537BefB7730e790143e2558945e9538fC2',
      4002: '0x9DB835D1927CC04E50fdeca0642eca06b26de719',
    },
    pool: {
      250: '0x9C7119d6a77BeA31FD518383FA036BC2C372ea6F',
      4002: '',
    },
    isMasterChefPool: true,
    getPriceFunc: 'price',
    image: 'series0.png',
    maxSupplyFunc: 'MAX_SUPPLY',
    disableMint: true,
    minDmdBalanceToMint: 10,
    nftkeyColName: 'dmdunboxedgenerals',
    operaHouse: 'Unboxed Generals',
  },
  {
    sid: 37,
    key: SeriesKey.FOUNDER_V2,
    name: 'Founder Token - V2',
    collectionName: 'Founder Token',
    address: {
      250: '0xf11cD86667A5a16E1a9d4971c9a518f3d447b8f3',
    },
    pool: {
      250: '0x0d2cFA0020B15C840748B1C7B3b1D7dFE90d4527',
    },
    isMasterChefPool: true,
    notFromERC721Enumerable: true,
    image: 'founder-token-v2.jpg',
    maxSupplyFunc: '_totalSupply',
    disableMint: true,
    paintswap: true,
    operaHouse: 'Founders Token',
  },
  {
    sid: 38,
    key: SeriesKey.SMOKERS,
    name: 'Silhouette Smokers',
    description:
      'A collection of 666 Silhouette Smokes, each more unique than the other. These shadows change with time but one thing is constant, a cigarette that burns at the edge of their lips.',
    address: {
      250: '0x429201af4ac3756673A4f6f5452d7cd32f1e8BD4',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'smokers.gif',
    releaseDate: '2022/06/11',
    discord: 'https://discord.gg/NNYCW4BT',
    twitter: 'https://twitter.com/silhouettesmoke',
    projectLink: 'https://medium.com/@silhouettesmokers',
    // nftkeyColName: '',
  },
  {
    sid: 39,
    key: SeriesKey.ALIENHEADS2D,
    name: 'Alien Heads 2D',
    description: 'The Second collection of Alien Heads in 2D with only a supply of 222.',
    address: {
      250: '0xF79dA28b4694eaECBFaae3AF92782Fbb52A460cC',
      4002: '',
    },
    withoutPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'alienheads2d.gif',
    releaseDate: '2022/06/08',
    discord: 'https://discord.gg/ZbmXBtucVy',
    twitter: 'https://twitter.com/alienheads_nft',
    // nftkeyColName: '',
  },
  {
    sid: 40,
    key: SeriesKey.MEMBERS,
    name: 'NFT Member',
    description: 'Minted by burning 1000 DMD! The utility of these 1269 Member Tokens will be revealed soon 👽',
    address: {
      250: '0x1d1aCbc92410296bA64EA3525c16A8e924FCa45A',
      4002: '0x58b66b1Db59f818C095ADd381B59De40F40A99d1',
    },
    token: tokens.dmd,
    withoutPool: true,
    getPriceFunc: 'pricetoken',
    maxSupplyFunc: 'maxSupply',
    isLaunchpad: true,
    image: 'members.png',
    releaseDate: '2022/06/11',
    // nftkeyColName: '',
  },
  {
    sid: 41,
    key: SeriesKey.SERIES1_V2,
    name: 'Series #1 - V2',
    boxType: 'Boxed Generals',
    address: {
      250: '0x10fa5F0dE00c788C11489308f67922022862b698',
      4002: '0xfba58904a995bDeC927fb03d3D3BA8894e3B3954',
    },
    pool: {
      250: '0x7Ee4CbEbea41FF40F8cbB3dE16fD4Cf71f4Ac329',
      4002: '',
    },
    isMasterChefPool: true,
    getPriceFunc: 'price',
    image: 'series1.jpeg',
    maxSupplyFunc: 'MAX_SUPPLY',
    disableMint: true,
    nftkeyColName: 'dmdboxedgenerals',
    operaHouse: 'Boxed Generals',
    // tofu: 'boxed-generals',
  },
  {
    sid: 42,
    key: SeriesKey.FRENCHIES_V2,
    name: 'Fantom Frenchies - V2',
    description:
      'The Fantom Frenchies is a collection of 690 Hiqh Quality, Hand Drawn French Bulldogs stored on the Fantom Blockchain.',
    address: {
      250: '0xB6902d67e75932A2d353c43490623D6B246f93aA',
      4002: '',
    },
    pool: {
      250: '0x5668fc1beb9e8ec32fcfedd95e07061b3ca6f05e',
      4002: '',
    },
    isMasterChefPool: true,
    getPriceFunc: 'price',
    maxSupplyFunc: 'maxSupply',
    disableMint: true,
    image: 'frenchies-v2.png',
    nftkeyColName: 'fantomfrenchies',
    operaHouse: 'FantomFrenchies',
    projectLink: 'https://fantomfrenchies.com',
    abilityKey: 'Bark',
  },
]

export default serieses
